import classNames from "classnames";
import styles from "../css/ChipButton.module.css";

interface ChipButtonProps {
  open: boolean;
  text: string;
  variant: "secondary" | "secondaryDisable";
  onClickAction: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export default function ChipButton(props: ChipButtonProps) {
  const containerClass = classNames(styles.container, {
    [styles.backgroundStyleSecondary]: props.variant === "secondary",
    [styles.backgroundStyleSecondaryDisable]:
      props.variant === "secondaryDisable",
  });

  const textClass = classNames(styles.text, {
    [styles.textStyleSecondary]: props.variant === "secondary",
    [styles.textStyleSecondaryDisable]: props.variant === "secondaryDisable",
  });

  if (!props.open) return null;

  return (
    <>
      <div className={containerClass} onClick={props.onClickAction}>
        <span className={textClass}>{props.text}</span>
      </div>
    </>
  );
}
